(() => {
  const roots = document.querySelectorAll('[data-curated-product-reviews]');

  roots.forEach((root) => {
    const track = root.querySelector('[data-curated-product-reviews-track]');
    const slides = Array.from(root.querySelectorAll('[data-curated-product-reviews-slide]'));
    const previousButton = root.querySelector('[data-curated-product-reviews-previous]');
    const nextButton = root.querySelector('[data-curated-product-reviews-next]');
    const dots = Array.from(root.querySelectorAll('[data-curated-product-reviews-dot]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!track || slides.length === 0) return;

    const getActiveIndex = () => {
      const trackLeft = track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - trackLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToSlide = (index) => {
      const nextIndex = Math.max(0, Math.min(index, slides.length - 1));

      slides[nextIndex].scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    };

    const updateControls = () => {
      const activeIndex = getActiveIndex();
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScroll - 2;

      if (previousButton) previousButton.disabled = atStart;
      if (nextButton) nextButton.disabled = atEnd;

      dots.forEach((dot, index) => {
        const isCurrent = index === activeIndex;

        dot.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      });
    };

    previousButton?.addEventListener('click', () => scrollToSlide(getActiveIndex() - 1));
    nextButton?.addEventListener('click', () => scrollToSlide(getActiveIndex() + 1));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => scrollToSlide(index));
    });

    let scrollFrame = null;

    track.addEventListener(
      'scroll',
      () => {
        if (scrollFrame) return;

        scrollFrame = window.requestAnimationFrame(() => {
          updateControls();
          scrollFrame = null;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateControls);
    updateControls();
  });
})();
